import * as React from "react";
import {fileTypes} from "../../../consts/consts";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";
import Textarea from "../../Textarea-new/Textarea";
import UploadFiles from "./UploadFiles";
import copyIcon from '../../../svgs/copy.svg';
import Icon from "../../Icon/Icon";

const items = [{
    label: 'Marketing Package',
    name: 'media_kit'
}];

const photos = [{
    label: 'Photo 1',
    name: 'website_photo_1',
}, {
    label: 'Photo 2',
    name: 'website_photo_2',
}, {
    label: 'Photo 3',
    name: 'website_photo_3',
}, {
    label: 'Photo 4',
    name: 'website_photo_4',
}, {
    label: 'Photo 5',
    name: 'website_photo_5',
}];

const Website = ({isAgent, data, handleChangeInput, handleChangeFile, viewMode, deleted}) => {

    const handleCopyFlipbookLink = React.useCallback(() => {
        if (data.flip_book_link) {
            navigator.clipboard.writeText(data.flip_book_link);
        }
    }, [data.flip_book_link]);
    
    return (
        <div className="Website">
            <div className="Website_actions">
                <Checkbox
                    text="STRIVE Slider"
                    type={viewMode ? "uncheckable" : "checkable"}
                    isSelected={data.strive_slider}
                    handleClick={handleChangeInput}
                    name="strive_slider"
                />
                <Checkbox
                    text="FEATURED"
                    type={viewMode ? "uncheckable" : "checkable"}
                    isSelected={data.featured}
                    handleClick={handleChangeInput}
                    name="featured"
                />
                <Checkbox
                    text="VISIBLE"
                    type={viewMode ? "uncheckable" : "checkable"}
                    isSelected={data.visible}
                    handleClick={handleChangeInput}
                    name="visible"
                />
            </div>
            <div className="Website_column">
                <UploadFiles
                    classNames="Website_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={items.length}
                    items={items}
                    disabled={isAgent}
                    canUploadManually
                    handleChangeInput={handleChangeInput}
                />
                {
                    viewMode ? (
                        <div className="Website_column_item">
                            <label style={{ fontWeight: 600, marginBottom: 4, display: "block" }}>Flipbook Link</label>
                            {data.flip_book_link ? (
                                <div className="Website_column_item" style={{ position: "relative" }}>
                                <a
                                    href={data.flip_book_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ wordBreak: "break-all", fontSize: "16px", color: "#7EB233", fontWeight: 600 }}
                                >
                                    {data.flip_book_link.length > 29
                                        ? data.flip_book_link.slice(0, 29) + "..."
                                        : data.flip_book_link}
                                </a>
                                <button
                                    type="button"
                                    onClick={handleCopyFlipbookLink}
                                    title = "Copy to clipboard"
                                    style={{
                                        background: "transparent",
                                        color: "#7EB233",
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "4px 12px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        fontWeight: 600, 
                                        height: 32
                                    }}
                                >
                                <Icon svg={copyIcon} 
                                    style= {{ width: 28, height: 28, color: '#7EB233' }}
                                />
                                </button>
                                 </div>
                            ) : (
                                <span style={{ fontSize: "14px" }}>-</span>
                            )}
                        </div>
                    ) : (
                            <Textarea
                                label="Flipbook Link"
                                name="flip_book_link"
                                value={data.flip_book_link}
                                maxWidth="100%"
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                style={{ flex: 1 }}
                            />
                            
                    )
                }

                <Input
                    className="Website_column_item"
                    type="text"
                    valueType="text"
                    name="video_url"
                    label="VIDEO_URL"
                    value={data.video_url}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Textarea
                    className="Website_column_item"
                    disabled={isAgent}
                    label="Highlights"
                    name="highlights"
                    value={data.highlights}
                    maxWidth="100%"
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Website_column">
                <UploadFiles
                    classNames="Website_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={photos.length}
                    items={photos}
                    disabled={isAgent}
                    fileType={fileTypes.Photo}

                />
            </div>
        </div>
    );
};

export default Website;
